import React from 'react';

const CategoryRatingBar = ({ rating }) => {
  const percentage = (rating.score / 10) * 100;
  
  const getBarColor = (score) => {
    if (score >= 8) return 'bg-emerald-500';
    if (score >= 6) return 'bg-[#D4AF37]';
    if (score >= 4) return 'bg-amber-500';
    return 'bg-red-500';
  };

  return (
    <div className="group" data-testid={`category-rating-${rating.category.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-sm text-stone-600">{rating.category}</span>
        <span className="font-serif text-lg font-medium text-stone-900">{rating.score}</span>
      </div>
      <div className="h-2 bg-stone-100 rounded-full overflow-hidden">
        <div 
          className={`h-full rounded-full transition-all duration-500 ${getBarColor(rating.score)}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <p className="text-xs text-stone-400 mt-1 opacity-0 group-hover:opacity-100 transition-opacity">
        {rating.reason}
      </p>
    </div>
  );
};

export default CategoryRatingBar;
